import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useEffect } from 'react'

function Verhaal() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='my-36 px-8'>

      {/* Intro */}
      <section className='items-center'>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
            I am Jo!
          </h1>
          <p className="text-base font-gotham">
            I am Jo! shows how art takes on new meaning in the lives of Amsterdammers today. The project celebrates the legacy of Jo van Gogh-Bonger as a symbol of perseverance, creativity, and solidarity and continues to build a community in which more than 100 women inspire one another to share their stories.
          </p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 2: Over Jo */}
      <section className='items-center'>
        <div className="mb-2 mx-auto max-w-4xl rounded-2xl overflow-hidden">
          <div className="relative w-full h-0 pb-[56.25%]">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              src="https://www.youtube.com/embed/x_iLSlZR4Ng?start=76"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>

          </div>
          <p className='font-gotham text-xs p-2 px-6'>video: Narjes Mohamadi & Rose Stories</p>
        </div>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
            Inspired by Jo
          </h1>
          <p className="text-base font-gotham">
            Johanna (Jo) van Gogh-Bonger (1862–1925) was the sister-in-law of Vincent van Gogh, and it was partly thanks to her that his work became world-famous. Jo grew up in a household full of music and literature and kept a diary from a young age, in which she explored her feelings, ideals, and ambitions in her lifelong search for self-knowledge. In 1889 she married Theo, Vincent’s brother. Their short but happy marriage was overshadowed by tragedy: first Vincent’s death in 1890, followed by Theo’s premature death just a few months later.
            <br></br><br></br>
            <div className='grid max-w-prose grid-cols-2 gap-6 my-4'>
              <div>
                <img
                  src={"/assets/images/vangoghmuseum-s0283V1963-800.jpg"}
                  alt={`${"hello"} Hover`}
                  className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
                />
                <p className='font-gotham text-xs p-2 px-6'>Johan Cohen Gosschalk, Portrait of Jo van Gogh-Bonger Writing, ca. 1902, Van Gogh Museum Amsterdam (Vincent van Gogh Foundation)</p>
                {/*         <p className='px-6 py-2 text-xs'>Portret van Jo van Gogh-Bonger schrijvende, Johan Cohen Gosschalk 1902 Van Gogh Museum Collection</p> */}
              </div>
              <div>
              <img
                src={"/assets/images/18mag-vangogh-promoimage-superJumbo.jpg"}
                alt={`${"hello"} Hover`}
                className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
              />
              <p className='font-gotham text-xs p-2 px-6'>Jo Bonger, 1884, Van Gogh Museum Amsterdam (Vincent van Gogh Foundation)</p>
              </div>
            </div>
            <br></br>
            In memory of her husband, Jo worked with tireless dedication to make Vincent’s work known. By publishing his letters, organizing exhibitions, and sharing his art with the world, she ensured that his work received the recognition it deserved. In her perseverance, ambition, and compassionate attitude, Jo van Gogh-Bonger remains a woman who captures the imagination and continues to inspire.</p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 2: Creativiteit en community */}
      <section className="items-center">
        <div className='grid max-w-4xl grid-cols-2 gap-6 items-center mx-auto'>
          <div>
          <img
            src={"/assets/images/download_13.jpg"}
            alt={`${"hello"} Hover`}
            className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
          />
          <p className='font-gotham text-xs p-2 px-6'>image: Van Gogh Museum</p>
          </div>
          <div>
          <img
            src={"/assets/images/download_24.jpg"}
            alt={`${"hello"} Hover`}
            className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
          />
          <p className='font-gotham text-xs p-2 px-6'>image: Van Gogh Museum</p>
          </div>
        </div>

        {/* TEXT — narrow & centered */}
        <div className="font-gotham text-black text-medium mx-auto max-w-prose my-12">
          <h1 className="my-6">
            Creativity and community
          </h1>
          <p className="text-base font-gotham">
            The Van Gogh Museum explores new ways to connect art with the lives of Amsterdammers today. By bringing Jo’s legacy to life, the museum aims to stimulate reflection, dialogue, and creativity and to present Jo as an inspiring example of resilience and determination.
          </p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 3: Van idee tot samenwerking */}
      <section className="mx-auto my-12 max-w-5xl px-4">
        <div className="flex flex-col gap-8 items-center md:flex-row md:items-start">
          <div className='flex-1'>
          <img
            src="/assets/images/BMS_0656-Enhanced-NR.jpg"
            alt="hello Hover"
            className="
        w-full
        h-auto object-cover
        rounded-3xl aspect-square
      "
          />
          <p className='font-gotham text-xs p-2 px-6'>image: Blooming Moon Studio</p>
          </div>
          <div className="font-gotham text-black mx-auto max-w-prose md:mx-0 md:flex-1">
            <h1 className="my-6">From idea to collaboration</h1>
            <p className="text-base font-gotham">
              In collaboration with the alliance Samen sterk met werk – which consists of Vrouw en Vaart (Nieuw-West), Buurvrouwennetwerk Gaasperdam (Zuidoost), Stichting Malak (Noord), Stichting Prachtvrouw (Oost) and Stichting Vrouwen Vooruit (West) – a series of creative workshops is being developed across Amsterdam.
              <br /><br />
              These activities invite women to discover Jo's story, draw inspiration from her life and  reflect on their own life journeys.
            </p>
          </div>
        </div>
      </section>


      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Documentary (keep video block) */}
      <section className='items-center'>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
            I am Jo!: Documentary
          </h1>
        </div>

        <div className="mb-2 mx-auto max-w-4xl rounded-2xl overflow-hidden">
          <div className="relative w-full h-0 pb-[56.25%]">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              src="https://www.youtube.com/embed/sSyWxNn-TIU?si=Om8_2TiN8Y0cl12n"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
          <p className='font-gotham text-xs p-2 px-6'>video: Mals Media</p>
        </div>

      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 4: Samen bouwen */}
      <section className='items-center'>
        <div className='grid max-w-4xl grid-cols-2 gap-6 items-center mx-auto'>

        </div>
        <div className="font-gotham text-black text-medium mx-auto max-w-prose my-12">
          <h1 className="my-6">
            Building together
          </h1>
          <p className="text-base font-gotham">
            The team of the Van Gogh Museum comes together with the participating organizations and ambassadors from across the city to explore Jo’s story and to reflect on how participants can connect with her on a personal level.
            <br></br><br></br>
            <div className='grid max-w-prose grid-cols-2 gap-6 my-4'>
            <div>
              <img
                src={"/assets/images/image2.jpg"}
                alt={`${"hello"} Hover`}
                className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
              />
              <p className='font-gotham text-xs p-2 px-6'>image: Van Gogh Museum</p>
              </div>
              <div>
              <img
                src={"/assets/images/image1.jpeg"}
                alt={`${"hello"} Hover`}
                className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
              />
              <p className='font-gotham text-xs p-2 px-6'>image: Van Gogh Museum</p>
              </div>
            </div>
            <br></br>
            These brainstorming sessions create space to exchange ideas, define goals, and gain a better understanding of the needs and challenges of everyone involved. By working according to the Design Thinking method, the group lays the foundation for a meaningful, practical, and impactful program for the women participating in the project.
          </p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 5: deelnemers */}
      <section className='items-center'>
        {/*       <img
          src={"/assets/images/BMS_1269.jpg"}
          alt={`${"hello"} Hover`}
          className="max-w-4xl mx-auto object-cover rounded-3xl my-8 aspect-[8/4] "
        /> */}
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
            The participants
          </h1>
          <p className="text-base font-gotham">
            During the workshops, many women arrive curious and often a little hesitant, because they don’t quite know what to expect. But as the activities unfold, more and more enjoyment emerges in making and finding their own creative voices.
            <br></br><br></br>
            What begins as a step into the unknown becomes a place for relaxation, reflection, and connection. Women who previously doubted their creative abilities are now proud of what they can create and share.
            <br></br><br></br>
            <div className='grid max-w-prose grid-cols-2 gap-6 my-4'>
              <div>
              <img
                src={"/assets/images/download_4.jpeg"}
                alt={`${"hello"} Hover`}
                className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
              />
              <p className='font-gotham text-xs p-2 px-6'>image: Van Gogh Museum</p>
              </div>
              <div>
              <img
                src={"/assets/images/BMS_0977.jpg"}
                alt={`${"hello"} Hover`}
                className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
              />
              <p className='font-gotham text-xs p-2 px-6'>image: Blooming Moon Studio</p>
              </div>
            </div>
            <br></br>
            Through group activities, humor, and moments of vulnerability, a strong sense of community emerges. For many, Jo’s story becomes a mirror, a reminder of their own resilience, while for others the collective experience of creativity and togetherness resonates most.
          </p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 6: Ontdekken van creativiteit */}
      <section className="items-center">
        <div className='grid max-w-4xl grid-cols-2 gap-6 items-center mx-auto'>
          <div>
          <img
            src={"/assets/images/download_23.jpg"}
            alt={`${"hello"} Hover`}
            className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
          />
          <p className='font-gotham text-xs p-2 px-6'>image: Van Gogh Museum</p>
          </div>
          <div>
          <img
            src={"/assets/images/MG_7419.jpg"}
            alt={`${"hello"} Hover`}
            className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
          />
          <p className='font-gotham text-xs p-2 px-6'>image: Van Gogh Museum</p>
          </div>
        </div>

        {/* TEXT — narrow & centered */}
        <div className="font-gotham text-black text-medium mx-auto max-w-prose my-12">
          <h1 className="my-6">
            Discovering creativity
          </h1>
          <p className="text-base font-gotham">
            During the workshops, women bring the story of both Jo and themselves to life through painting, drawing, writing, mosaics, embroidery, ceramics, and calligraphy.
            <br></br><br></br>
            They create personal self-portraits and collaborative artworks, experimenting with colors, materials, and motifs.
            <br></br><br></br>
            Each activity invites reflection, playful exploration, and connection, helping participants discover new creative skills, gain confidence, and share meaningful moments with one another.
          </p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 7: Vrouwenstemmen vieren */}
      <section className="items-center">
        <div className='mx-auto max-w-4xl'>
          <img
            src={"/assets/images/BMS_1045.jpg"}
            alt={`${"hello"} Hover`}
            className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
          />
          <p className='font-gotham text-xs p-2 px-6'>image: Blooming Moon Studio</p>
        </div>

        {/* TEXT — narrow & centered */}
        <div className="font-gotham text-black text-medium mx-auto max-w-prose my-12">
          <h1 className="my-6">
            Celebrating women’s voices
          </h1>
          <p className="text-base font-gotham">
            I am Jo! is celebrated with a series of public events that bring the story of Jo van Gogh-Bonger and the voices of the participants to the attention of a wider audience.
          </p>
        </div>
      </section>



      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Event: Pakhuis de Zwijger */}
      <section className='items-center'>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Event</tag>
          <h1 className="my-6">
            I am Jo!: Pakhuis de Zwijger
          </h1>
        </div>

        <div className="mb-2 mx-auto max-w-4xl rounded-2xl overflow-hidden">
          <div className="relative w-full h-0 pb-[56.25%]">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              src="https://www.youtube.com/embed/AZ1MSXo-7X8?si=XZjksksDYbsuCwfH"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
          <p className='font-gotham text-xs p-2 px-6'>video: Pakhuis de Zwijger</p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Event: Vrouwendag */}
      <section className="mx-auto my-12 max-w-5xl">
  <div className="flex flex-col gap-8 items-center md:flex-row md:items-center">
    {/* LEFT column */}
    <div className="w-full md:w-1/2">
      <img
        src="/assets/images/BMS_1161.jpg"
        alt="hello Hover"
        className="w-full h-auto object-cover rounded-3xl aspect-square"
      />
      <p className="font-gotham text-xs p-2 px-6">image: Blooming Moon Studio</p>
    </div>

    {/* RIGHT column */}
    <div className="w-full md:w-1/2 font-gotham text-black text-medium mx-auto max-w-prose my-6">
      <span className="font-gotham text-background bg-black rounded-full px-4 py-2 font-bold">
        Event
      </span>
      <h1 className="my-6">I am Jo!: International Women’s Day</h1>
    </div>
  </div>
</section>


      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Tentoonstelling: Van gogh */}
      <section className="items-center">

        {/* TEXT — narrow & centered */}
        <div className="font-gotham text-black text-medium mx-auto max-w-prose my-6">
          <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Exhibition</tag>
          <h1 className="my-6">
            I am Jo!: Van Gogh Museum
          </h1>
        </div>

        {/* IMAGE */}
        <div className='mx-auto max-w-4xl'>
          <img
            src={"/assets/images/BMS_0846.jpg"}
            alt={`${"hello"} Hover`}
            className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
          />
          <p className="font-gotham text-xs p-2 px-6">image: Blooming Moon Studio</p>
        </div>


      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Event: Conservatorium*/}
      <section className="mx-auto my-12 max-w-5xl">
  <div className="flex flex-col gap-8 items-center md:flex-row md:items-center">


              {/* LEFT column */}
    <div className="w-full md:w-1/2">
      <img
            src={"/assets/images/Ik-ben-Jo_opening-Conservatorium-Hotel13.jpeg"}
        alt="hello Hover"
        className="w-full h-auto object-cover rounded-3xl aspect-square"
      />
      <p className="font-gotham text-xs p-2 px-6">image: Blooming Moon Studio</p>
    </div>

        <div className="w-full md:w-1/2 font-gotham text-black text-medium mx-auto max-w-prose my-6">
      <span className="font-gotham text-background bg-black rounded-full px-4 py-2 font-bold">
        Event
      </span>
      <h1 className="my-6">I am Jo!: Conservatorium Hotel</h1>
    </div>
    </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Tentoonstelling: OBA */}
      <section className="items-center">

        {/* TEXT — narrow & centered */}
        <div className="font-gotham text-black text-medium mx-auto max-w-prose my-6">
          <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Exhibition</tag>
          <h1 className="my-6">
            I am Jo!: Openbare Bibliotheek Amsterdam
          </h1>
        </div>

        {/* IMAGE */}
        <div className='mx-auto max-w-4xl'>
          <img
            src={"/assets/images/BMS_1836NWest.jpg"}
            alt={`${"hello"} Hover`}
            className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
          />
          <p className="font-gotham text-xs p-2 px-6">image: Van Gogh Museum</p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Event: Premiere docu */}

      <section className="mx-auto my-12 max-w-5xl">
  <div className="flex flex-col gap-8 items-center md:flex-row md:items-center">


              {/* LEFT column */}
    <div className="w-full md:w-1/2">
      <img
            src={"/assets/images/BMS_2431.jpg"}
        alt="hello Hover"
        className="w-full h-auto object-cover rounded-3xl aspect-square"
      />
      <p className="font-gotham text-xs p-2 px-6">image: Blooming Moon Studio</p>
    </div>

        <div className="w-full md:w-1/2 font-gotham text-black text-medium mx-auto max-w-prose my-6">
      <span className="font-gotham text-background bg-black rounded-full px-4 py-2 font-bold">
        Event
      </span>
      <h1 className="my-6">Premiere: I am Jo! (documentary</h1>
    </div>
    </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Event: Bijlmerpark theater */}
      <section className="items-center">

        {/* TEXT — narrow & centered */}
        <div className="font-gotham text-black text-medium mx-auto max-w-prose my-6">
          <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Event</tag>
          <h1 className="my-6">
            I am Jo!: Bijlmer Parktheater
          </h1>
        </div>

        {/* IMAGE */}
        <div className='mx-auto max-w-4xl'>
          <img
            src={"/assets/images/bijlmerpark theater event.jpeg"}
            alt={`${"hello"} Hover`}
            className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
          />
          <p className="font-gotham text-xs p-2 px-6">image: Blooming Moon Studio</p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 8: Nalatenschap */}
      <section className='items-center'>
        <div className='mx-auto max-w-4xl'>
          <img
            src={"/assets/images/BMS_0955.jpg"}
            alt={`${"hello"} Hover`}
            className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
          />
          <p className="font-gotham text-xs p-2 px-6">image: Blooming Moon Studio</p>
        </div>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
            Legacy
          </h1>
          <p className="text-base font-gotham">
            The project leaves a lasting impression on both participants and museum visitors. Women discover new skills, gain more self-confidence, and build meaningful relationships through shared experiences. Visitors to the exhibition in June 2025, where the results of the project are presented, contribute messages and drawings for the women, creating an additional layer of connection and recognition.
            <br></br><br></br>
            <div className="grid max-w-prose grid-cols-2 gap-6 my-4">
              <div>
              <img
                src="/assets/images/sketch4.png"
                alt=""
                className="w-full mx-auto object-contain rounded-3xl"
              />
                            <p className="font-gotham text-xs p-2 px-6">image: Van Gogh Museum</p>
</div>
<div>
              <img
                src="/assets/images/sketch3.png"
                alt=""
                className="w-full mx-auto object-contain rounded-3xl"
              />
              <p className="font-gotham text-xs p-2 px-6">image: Van Gogh Museum</p>
              </div>
            </div>

            <br></br>
            In addition to the activities, the project fosters a sense of empowerment, curiosity, and community that continues to inspire participants, partners, and audiences. This lays the foundation for future initiatives and engagement with the museum and communities throughout Amsterdam.</p>
        </div>
      </section>

    </div>
  );
}

export default Verhaal;
